import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import { IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_LEASING_SERVICE_TYPES_READ } from 'constants/rightsCodes';
import FlexBox from 'components/common/FlexBox';
import HeaderPortal from 'components/layout/HeaderPortal';
import LinkingsComponent from './LinkingsComponent';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const { t } = useTranslation();

  const canRead = usePermission(ADMIN_LEASING_SERVICE_TYPES_READ);

  const navigateToList = useCallback(() => {
    historyContext.push('/leasingServiceTypes');
  }, [historyContext]);

  return (
    <>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <FlexBox gap={0.5} id='service-linking-actions'>
          {canRead && (
            <IconButton tooltip={t('LeasingServiceType.ServiceTypesList')} variant='text' color='primary' onClick={navigateToList}>
              <ListAltIcon />
            </IconButton>
          )}
        </FlexBox>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_LEASING_SERVICE_TYPES_READ}>
        <LinkingsComponent />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
